export default __webpack_public_path__ + "87761334aabfc50befb2732a6b565cc5.svg";